export default {
    enabled: false,
    enterRequested: false,
    deviceRequired: false,
    approved: false,
    disapproved: false,
    noPermission: false,
    noManagerInRoom: false,
    roomClosed: false,
    waitingList: [],
    unchecked: false,
}
